import { Space, Button, Popconfirm, Tooltip, Input, InputNumber, DatePicker } from "antd";
import { EditOutlined, DeleteOutlined, PrinterOutlined, EyeOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

import { docLinkRender } from "../../../components/table/DocLink";
const money = (v, d = 2) =>
  Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d });

/* ── ตารางหน้ารายการ ── */
export const accessColumn = ({ handleView, handleEdit, handleDelete, handlePrint }) => [
  {
    title: "เลขที่ Packing List",
    key: "pk_code",
    dataIndex: "pk_code",
    width: 150,
    /* กดเลขที่เอกสารเพื่อเปิดหน้าแสดงข้อมูล */
    render: docLinkRender(handleView, "เปิดดู Packing List"),
  },
  {
    title: "เลขที่ใบส่งมอบ",
    key: "delcode",
    dataIndex: "delcode",
    width: 140,
  },
  {
    title: "เลขที่ Invoice",
    key: "inv_no",
    dataIndex: "inv_no",
    width: 130,
  },
  {
    title: "ลูกค้า",
    key: "cusname",
    dataIndex: "cusname",
    width: 200,
  },
  {
    title: "วันที่เอกสาร",
    key: "pk_date",
    dataIndex: "pk_date",
    width: 120,
    align: "center",
    render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "-"),
  },
  {
    title: "ปลายทาง",
    key: "final_destination",
    dataIndex: "final_destination",
    width: 180,
  },
  {
    title: "GW (KG)",
    key: "gross_weight",
    dataIndex: "gross_weight",
    width: 110,
    align: "right",
    render: (v) => money(v),
  },
  {
    title: "สร้างโดย",
    key: "created_name",
    dataIndex: "created_name",
    width: 150,
  },
  {
    title: "Action",
    key: "action",
    fixed: "right",
    width: 180,
    render: (_, record) => (
      <Space>
        <Button
          size="small"
          icon={<EyeOutlined />}
          className="bn-success-outline"
          title="ดูข้อมูล"
          style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
          onClick={() => handleView(record)}
        />
        <Tooltip title="แก้ไข">
          <Button
            size="small"
            icon={<EditOutlined />}
            className="bn-primary-outline"
            style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
            onClick={() => handleEdit(record)}
          />
        </Tooltip>
        <Tooltip title="พิมพ์ Packing List">
          <Button
            size="small"
            icon={<PrinterOutlined />}
            className="bn-warning-outline"
            style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
            onClick={() => handlePrint(record)}
          />
        </Tooltip>
        <Popconfirm
          title="ยืนยันการลบ?"
          onConfirm={() => handleDelete(record)}
          okText="ลบ"
          cancelText="ยกเลิก"
        >
          <Button
            size="small"
            danger
            icon={<DeleteOutlined />}
            style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
          />
        </Popconfirm>
      </Space>
    ),
  },
];

/* ── ตารางเลือกใบส่งมอบใน Modal ── */
export const deliveryColumn = () => [
  { title: "เลขที่ใบส่งมอบ", dataIndex: "delcode", key: "delcode", width: 140 },
  { title: "Job Order", dataIndex: "jocode", key: "jocode", width: 110, align: "center" },
  { title: "โหลด", dataIndex: "load_no", key: "load_no", width: 70, align: "center" },
  { title: "ลูกค้า", dataIndex: "cusname", key: "cusname", width: 200 },
  { title: "Brand", dataIndex: "brand", key: "brand", width: 140 },
  {
    title: "วันที่ส่งมอบ", dataIndex: "dlvdate", key: "dlvdate", width: 120, align: "center",
    render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "-"),
  },
  {
    title: "จำนวน/กล่อง", dataIndex: "total_carton", key: "total_carton", width: 110, align: "right",
    render: (v) => Number(v || 0).toLocaleString(),
  },
];

/* ── ตารางรายการสินค้าในฟอร์ม (แก้ไขได้) ──
   เรียงคอลัมน์ตามฟอร์ม PACKING LIST */
export const detailColumns = ({ updateDetail, deleteDetail, readOnly = false }) => [
  {
    title: "MARK", key: "mark", width: 150,
    render: (_, record, index) => (
      <Input
        value={record.mark}
        placeholder="MARK"
        onChange={(e) => updateDetail(index, "mark", e.target.value)}
      />
    ),
  },
  {
    title: "QUANTITY CASE", key: "quantity_case", width: 130, align: "right",
    render: (_, record, index) => (
      <InputNumber
        value={record.quantity_case}
        min={0}
        style={{ width: "100%" }}
        onChange={(val) => updateDetail(index, "quantity_case", val)}
      />
    ),
  },
  {
    title: "PACKING SIZE", key: "packing_size", width: 130,
    render: (_, record, index) => (
      <Input
        value={record.packing_size}
        placeholder="เช่น 12x100G"
        onChange={(e) => updateDetail(index, "packing_size", e.target.value)}
      />
    ),
  },
  { title: "ITEM", key: "seq", dataIndex: "seq", width: 60, align: "center" },
  {
    title: "DESCRIPTION OF PRODUCT", key: "pg_name", width: 250,
    render: (_, record, index) => (
      <Input
        value={record.pg_name}
        onChange={(e) => updateDetail(index, "pg_name", e.target.value)}
      />
    ),
  },
  {
    title: "PROD. DATE", key: "production_date", width: 140, align: "center",
    render: (_, record, index) => (
      <DatePicker
        value={record.production_date}
        format="DD/MM/YYYY"
        style={{ width: "100%" }}
        onChange={(val) => updateDetail(index, "production_date", val)}
      />
    ),
  },
  {
    title: "EXP. DATE", key: "expiry_date", width: 140, align: "center",
    render: (_, record, index) => (
      <DatePicker
        value={record.expiry_date}
        format="DD/MM/YYYY"
        style={{ width: "100%" }}
        onChange={(val) => updateDetail(index, "expiry_date", val)}
      />
    ),
  },
  {
    title: "NW (KG)", key: "net_weight", width: 120, align: "right",
    render: (_, record, index) => (
      <InputNumber
        value={record.net_weight}
        min={0}
        step={0.01}
        style={{ width: "100%" }}
        onChange={(val) => updateDetail(index, "net_weight", val)}
      />
    ),
  },
  {
    title: "GW (KG)", key: "gross_weight", width: 120, align: "right",
    render: (_, record, index) => (
      <InputNumber
        value={record.gross_weight}
        min={0}
        step={0.01}
        style={{ width: "100%" }}
        onChange={(val) => updateDetail(index, "gross_weight", val)}
      />
    ),
  },
  ...(readOnly
    ? []
    : [
        {
          title: "", key: "action", width: 50, align: "center", fixed: "right",
          render: (_, record) => (
            <Button
              type="text" danger size="small" icon={<DeleteOutlined />}
              onClick={() => deleteDetail(record.seq)}
            />
          ),
        },
      ]),
];
